import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'ReadBoardColumnsV3'>
type Response = OpalApiResponseDocument<'ReadBoardColumnsV3', 200>

export function readBoardColumns({
  params,
}: {
  params: Params
}): Promise<Response> {
  const url = new URL(
    `/boards/v3/${params.path.board_id}/board_columns`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
